module.exports = "/images/seeMore.svg";